// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2oxgd","content":"RecentSearches_content__TPrtL"};